<div class="d-flex justify-content-end mb-3">
  <button
    id="adminorcustomer_organizations_soarrules_traveladvisories_addnew"
    type="button"
    class="cyflare-btn-primary"
    (click)="openEditor()"
  >
    Add new
  </button>
</div>

@if (datatableUrl(); as url) {
  <app-datatable
    [data-href]="url"
    [columns]="datatableColumns"
    [useOData]="true"
    (click)="onTableClick($event)"
  ></app-datatable>
}

@if (formGroup(); as form) {
  <kendo-dialog
    [title]="isNew() ? 'Add Travel Advisory' : 'Edit Travel Advisory'"
    [width]="520"
    [minWidth]="340"
    (close)="closeEditor()"
  >
    <form [formGroup]="form">
      <div class="mb-3">
        <label
          class="form-label small text-muted mb-1"
          for="adminorcustomer_organizations_soarrules_traveladvisories_email"
        >
          Travelers Email
        </label>
        <input
          id="adminorcustomer_organizations_soarrules_traveladvisories_email"
          class="form-control"
          formControlName="email"
        />
      </div>

      <div class="mb-3">
        <label class="form-label small text-muted mb-1">Destination</label>
        <kendo-dropdownlist
          id="adminorcustomer_organizations_soarrules_traveladvisories_destination"
          [data]="data"
          [filterable]="true"
          (filterChange)="handleFilter($event)"
          textField="text"
          valueField="value"
          [defaultItem]="{ text: 'Select a country...', value: null }"
          [valuePrimitive]="true"
          formControlName="destination"
        ></kendo-dropdownlist>
      </div>

      <div class="mb-3">
        <label class="form-label small text-muted mb-1">Trip Start Date</label>
        <kendo-datepicker
          id="adminorcustomer_organizations_soarrules_traveladvisories_startdate"
          formControlName="start_date"
          [twoDigitYearMax]="99"
          format="MM/dd/yyyy"
          [formatPlaceholder]="{ year: 'yyyy', month: 'MM', day: 'dd' }"
          placeholder="MM/dd/yyyy"
        ></kendo-datepicker>
      </div>

      <div class="mb-2">
        <label class="form-label small text-muted mb-1">Trip End Date</label>
        <kendo-datepicker
          id="adminorcustomer_organizations_soarrules_traveladvisories_enddate"
          formControlName="end_date"
          [twoDigitYearMax]="99"
          format="MM/dd/yyyy"
          [formatPlaceholder]="{ year: 'yyyy', month: 'MM', day: 'dd' }"
          placeholder="MM/dd/yyyy"
        ></kendo-datepicker>
      </div>
    </form>

    <kendo-dialog-actions>
      <button
        id="adminorcustomer_organizations_soarrules_traveladvisories_cancel"
        type="button"
        class="cyflare-btn-secondary cyflare-btn-sm"
        [disabled]="isSaving()"
        (click)="closeEditor()"
      >
        Cancel
      </button>
      <button
        id="adminorcustomer_organizations_soarrules_traveladvisories_save"
        type="button"
        class="cyflare-btn-primary cyflare-btn-sm"
        [disabled]="isSaving()"
        (click)="save()"
      >
        @if (isSaving()) {
          <span
            class="spinner-border spinner-border-sm me-1"
            role="status"
          ></span>
          Saving...
        } @else {
          {{ isNew() ? 'Add' : 'Update' }}
        }
      </button>
    </kendo-dialog-actions>
  </kendo-dialog>
}
